import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import ThemeForm, { IThemeFormValues } from 'app-support/themes/components/ThemeForm'
import { createTheme } from 'app-support/themes/state/actions'
import { useNotifier } from '@cbgms/base/notifier'
import { useHistory } from 'react-router-dom'

const initialValues: IThemeFormValues = {
  UUID: '',
  IsActive: false,
  LogoURL: '',
  LogoSmallURL: '',
  Name: '',
  MainColour: '#cfcfcf',
  MainColourText: '#000000'
}

const NewThemeForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const history = useHistory()

  const onSubmit = async (values: IThemeFormValues) => {
    try {
      const { Data } = await dispatch(createTheme(values))

      return { ...values, UUID: Data.UUID }
    } catch (error) {
      throw generateSubmissionError(error)
    }
  }

  const onSubmitAndDone = async (values: any) => {
    await onSubmit(values)
  }

  const onSubmitSuccess = (values: IThemeFormValues) => {
    notifier.success(t('theme.created_successfully'))
    history.push(`/themes/edit/${values.UUID}`)
  }

  return (
    <ThemeForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitAndDone={onSubmitAndDone}
      onSubmitSuccess={onSubmitSuccess}
      title={t('theme.newTitle')}
      redirectToURL='/themes'
    />
  )
}

export default NewThemeForm
